/**
 * 侧边栏组件
 */
import React from 'react';
import { Layout, Menu, Typography, Drawer } from 'antd';
import type { MenuProps } from 'antd';
import { getMenuItems } from './menuConfig';

const { Sider } = Layout;
const { Text } = Typography;

interface SidebarProps {
  collapsed: boolean;
  isMobile: boolean;
  mobileDrawerVisible: boolean;
  selectedKeys: string[];
  openKeys: string[];
  userPermissions?: string[];
  onMenuClick: MenuProps['onClick'];
  onDrawerClose: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  isMobile,
  mobileDrawerVisible,
  selectedKeys,
  openKeys,
  userPermissions,
  onMenuClick,
  onDrawerClose,
}) => {
  const menuItems = getMenuItems(userPermissions);

  const renderMenu = () => (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={selectedKeys}
      defaultOpenKeys={openKeys}
      items={menuItems}
      onClick={onMenuClick}
      style={{ 
        borderRight: 0,
        background: 'transparent',
      }}
    />
  );

  // 移动端抽屉菜单
  if (isMobile) {
    return (
      <Drawer
        title="菜单"
        placement="left"
        onClose={onDrawerClose}
        open={mobileDrawerVisible}
        width={280}
        bodyStyle={{ padding: 0, background: 'linear-gradient(180deg, #d1d9df 0%, #c1cbd3 100%)' }}
        styles={{ header: { background: 'rgba(224, 230, 234, 0.96)', borderBottom: '1px solid rgba(16, 27, 35, 0.08)' } }}
      >
        <Menu
          mode="inline"
          selectedKeys={selectedKeys}
          defaultOpenKeys={openKeys}
          items={menuItems}
          onClick={onMenuClick}
          style={{ borderRight: 0, background: 'transparent' }}
        />
      </Drawer>
    );
  }

  // 桌面端侧边栏
  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={220}
      collapsedWidth={80}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: 101,
        background: 'linear-gradient(180deg, #c7d1d8 0%, #bcc8d0 100%)',
        borderRight: '1px solid rgba(16, 27, 35, 0.08)',
        boxShadow: '12px 0 32px rgba(46, 60, 70, 0.08)',
      }}
    >
      <div
        style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid rgba(16, 27, 35, 0.08)',
          background: 'rgba(232, 237, 240, 0.76)',
        }}
      >
        <Text
          strong
          style={{
            color: '#10171d',
            fontSize: collapsed ? 14 : 18,
            whiteSpace: 'nowrap',
            letterSpacing: '0.08em',
          }}
        >
          {collapsed ? '斌宇' : '斌宇林建'}
        </Text>
      </div>
      {renderMenu()}
    </Sider>
  );
};
